<template>
  <div>
    <button
      v-if="!item.children"
      type="button"
      class="nd-menu-item"
      :class="{ 'nd-menu-item--active': isActive(item) }"
      :title="item.name"
      :aria-label="item.name"
      @click="handleItemClick(item)"
    >
      <v-icon size="20" class="nd-menu-item__icon">{{ item.icon }}</v-icon>
      <span>{{ item.name }}</span>
    </button>

    <v-list-group v-else no-action :value="isGroupActive" class="nd-menu-item-group">
      <template v-slot:activator>
        <v-list-item-icon>
          <v-icon size="20">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </template>

      <template v-for="(childItem, index) in item.children">
        <button
          v-if="!childItem.path || $check(childItem.path, 'GET')"
          :key="index"
          type="button"
          class="nd-menu-item nd-menu-item--child"
          :class="{ 'nd-menu-item--active': isActive(childItem) }"
          @click="handleItemClick(childItem)"
        >
          <span>{{ childItem.name }}</span>
        </button>
      </template>
    </v-list-group>
  </div>
</template>

<script>
import { eventHub } from "@/main";

export default {
  name: "MenuItem",

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isGroupActive() {
      return !!(this.item.children || []).find((child) => this.isActive(child));
    },
  },

  methods: {
    isActive(item) {
      if (!item.route) return false;
      return this.$route.path === item.route || this.$route.path.indexOf(`${item.route}/`) === 0;
    },

    handleItemClick(item) {
      if (item.event) {
        eventHub.$emit(item.event);
        return;
      }

      eventHub.$emit("close-menu");

      if (item.route && this.$route.path !== item.route) {
        this.$router.push(item.route).catch(() => {});
      }
    },
  },
};
</script>
